import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';

import TeamsPage from './components/TeamsPage';
import AccountsPage from './components/AccountsPage';
import WorkspacesPage from './components/WorkspacesPage';

const Admin = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Route exact path={`${match.path}/teams`} component={TeamsPage} />
      <Route exact path={`${match.path}/accounts`} component={AccountsPage} />
      <Route exact path={`${match.path}/workspaces`} component={WorkspacesPage} />
      <Redirect to={`${match.path}/accounts`} />
    </Switch>
    <HelpMenu />
  </React.Fragment>
);

Admin.propTypes = {
  match: PropTypes.object,
};

export default Admin;
